import { SERVER_URL } from '../../../constants';
import {
  fetchGetAuth,
} from '../../../util/FetchUtil';

const controller = 'cantina-saldo/';

export const findSaldoCantinaByCurrentUser = () => {
  const url = SERVER_URL + controller + "query-unique?type=current-user";
  return fetchGetAuth(url);
}
export const findSaldoCantinaByAlunoCodigo = (codAluno) => {
  const url = SERVER_URL + controller + "query-unique?cod-aluno=" + codAluno;
  return fetchGetAuth(url);
}